import * as React from "react";
import "../../style/fonts.css";
import "./quitSmoking.css";
import devicePlusApp1x from "../../icons/device_plus_app.png";
import devicePlusApp2x from "../../icons/device_plus_app@2x.png";
import devicePlusApp3x from "../../icons/device_plus_app@3x.png";
import CtaButton from "../ctaButton/ctaButton";
import translate from "../../translations/i18n";

class QuitSmoking extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.redirectToSmokeless = this.redirectToSmokeless.bind(this);
  }

  redirectToSmokeless() {
    window.location.href = "https://smokeless.world/";
  }

  render() {
    return (
      <div className="FLEX_CONT_QUIT_SMOKING">
        <div className="QUIT_SMOKING_CONT">
          <div className="QUIT_SMOKING_TITLES_CONT">
            <div className="QUIT_SMOKING_TITLE">
              <div className="QUIT_SMOKING_TITLE_2">
                {translate("WEBAPP_AD_TITLE")}
              </div>
            </div>
            <div className="QUIT_SMOKING_SUBTITLE_1">
              <div className="SMALL_TEXT1">
                {translate("WEBAPP_AD_SUBTITLE")}
              </div>
            </div>
            <div className="QUIT_SMOKING_SUBTITLE_2">
              <div className="TITLE_3" style={{ lineHeight: "20px" }}>
                {translate("WEBAPP_AD_BULLET_1")}
                <br />
                {translate("WEBAPP_AD_BULLET_2")}
                <br />
                {translate("WEBAPP_AD_BULLET_3")}
              </div>
            </div>
          </div>
          <div className="OVAL_CONT">
            <div className="OVAL_IMG_CONT">
              <img
                src={devicePlusApp1x}
                srcSet={`${devicePlusApp1x} 1x, ${devicePlusApp2x} 2x, ${devicePlusApp3x} 3x`}
              />
            </div>
          </div>
        </div>
        <div
          className="MORE_ABOUT_SMOKELESS_CONT"
          onClick={this.redirectToSmokeless}
        >
          <CtaButton
            width={"280px"}
            text={"MORE ABOUT SMOKELESS"}
            color={"blue"}
          />
        </div>
      </div>
    );
  }
}

export default QuitSmoking;



// WEBPACK FOOTER //
// ./src/components/screens/quitSmoking.tsx